import type { Messages } from "@prop/i18n";
import type en from "../en/auth";

export default {
  email: "Correo electrónico",
  password: "Contraseña",
  passwordHint: "Al menos 8 caracteres.",
  displayName: "Nombre",
  optional: "opcional",
  showPassword: "Mostrar contraseña",
  hidePassword: "Ocultar contraseña",
  or: "o",
  submit: {
    login: "Iniciar sesión",
    register: "Crear cuenta",
    verify: "Confirmar",
    send: "Enviar enlace",
    reset: "Guardar nueva contraseña",
  },
  login: {
    title: "Iniciar sesión",
    noAccount: "¿Eres nuevo?",
    toRegister: "Crea una cuenta",
    forgot: "¿Olvidaste tu contraseña?",
  },
  register: {
    title: "Crea tu cuenta",
    subtitle: "Una cuenta gratis en un minuto: un correo y una contraseña, o Telegram con un solo toque.",
    haveAccount: "¿Ya tienes cuenta?",
  },
  fieldErrors: {
    email: "Escribe un correo como nombre@ejemplo.com",
    password: "Al menos 8 caracteres",
  },
  telegram: {
    button: "Continuar con Telegram",
    notConfigured: "El inicio de sesión con Telegram aún no está disponible",
    opening: "Abriendo Telegram…",
    waitingTitle: "Confirma en Telegram",
    waitingHint: "En @{bot}, toca “Confirmar inicio de sesión”. Esta página iniciará tu sesión sola.",
    waitingHintStepUp: "En @{bot}, toca “Confirmar”. Esta ventana continuará sola.",
    stepOpen: "Abre el bot",
    stepConfirm: "Toca Confirmar",
    stepBack: "Vuelve aquí",
    openAgain: "Abrir Telegram de nuevo",
    openWeb: "Abrir en el navegador",
    qr: "¿No tienes Telegram en esta computadora? Escanea con la cámara de tu teléfono.",
    cancel: "Cancelar",
    expired: "La solicitud expiró. Empieza de nuevo: toma un segundo.",
    unavailable: "No se pudo iniciar sesión con Telegram. Revisa la conexión e inténtalo de nuevo",
  },
  mfa: {
    title: "Verificación en dos pasos",
    totpLabel: "Código de tu app de autenticación",
    useKey: "Usar una llave de seguridad o passkey",
    useRecovery: "Usar un código de recuperación",
    useTotp: "Usar la app de autenticación",
    recoveryLabel: "Código de recuperación",
    keyWaiting: "Sigue las indicaciones de tu navegador…",
  },
  forgot: {
    title: "Restablecer contraseña",
    subtitle: "Te enviaremos por correo un enlace para crear una nueva contraseña.",
    sent: "Si existe una cuenta con este correo, el enlace va en camino. Revisa tu bandeja de entrada.",
  },
  reset: {
    title: "Crea una nueva contraseña",
    done: "Contraseña cambiada. Se cerraron todas tus sesiones: vuelve a iniciar sesión.",
  },
  verify: {
    optional: "Aún sin confirmar (opcional).",
    sendLink: "Enviar un enlace",
    title: "Confirmación de correo",
    working: "Confirmando…",
    done: "Tu correo está confirmado.",
    banner: "Confirma tu correo: enviamos un enlace a {email}.",
    resend: "Enviar de nuevo",
    resent: "Enviado.",
  },
  toLogin: "Volver a iniciar sesión",
  passwordProblems: {
    too_short: "Muy corta: al menos 8 caracteres",
    too_long: "Muy larga",
    contains_email: "No debe contener el nombre de tu correo",
    too_simple: "Muy simple: usa más caracteres distintos",
  },
} satisfies Messages<typeof en>;
